/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react';
import { Col, Container, Form, FormCheck, Row } from 'react-bootstrap';
import styles from '../DayEntry/DayEntry.module.scss';
import Signature from '../Signature/Signature';
import TextInput from '../TextInput/TextInput';
import Multiselect from 'multiselect-react-dropdown';
import moment from 'moment-timezone';

const Questions = ({
    dayEntry,
    weekDays,
    setQuestionResponses,
    dutyFreeLunchSchoolInitials,
    dutyFreeBreakSchoolInitials,
    dutyFreeLunchSchoolSigTouched,
    dutyFreeBreakSchoolSigTouched,
    setDutyFreeLunchSchoolSigTouched,
    setDutyFreeBreakSchoolSigTouched,
    isTimesheetSubmit,
    setIsQuestionValidate,
    state
}) => {
    const radios = [
        { name: 'Yes', value: 'true' },
        { name: 'No', value: 'false' },
    ];

    const waiveLunch = [
        { name: 'Yes', value: 'true' },
        { name: 'N/A', value: 'false' },
    ]

    const [isDutyFreeLunch, setIsDutyFreeLunch] = useState('');
    const [isDutyFreeBreak, setIsDutyFreeBreak] = useState('');
    const [isWaiveMinimum, setIsWaiveMinimum] = useState('');
    const [dutyFreeLunchDates, setDutyFreeLunchDates] = useState([])
    const [dutyFreeLunchReason, setDutyFreeLunchReason] = useState('');
    const [dutyFreeBreakDates, setDutyFreeBreakDates] = useState([])
    const [dutyFreeBreakReason, setDutyFreeBreakReason] = useState('');
    const [explanation, setExplanation] = useState('');

    const options = useMemo(() => {
        return dayEntry.map((day) => ({
            name: moment(day.date).format("MMMM Do YYYY"),
            id: moment(day.date).format("MMMM Do YYYY")
        }));
    }, [dayEntry]);

    const isOtherSelected = useMemo<boolean>(() => {
        return dayEntry.some((day) => {
            return weekDays.some((weekDay) => {
                return day[`${weekDay.toLowerCase()}HoursType1`] === 'other';
            });
        });
    }, [dayEntry]);

    const validateQuestionResponses = () => {
        let isValid = true;

        if (isOtherSelected && !explanation) {
            isValid = false;
        }

        if (state === "CA" && isValid) {
            if (isDutyFreeBreak === '') {
                isValid = false;
            } else if (isDutyFreeLunch === '') {
                isValid = false;
            } else if (isWaiveMinimum === '') {
                isValid = false;
            } else if (isDutyFreeLunch === 'false' && !dutyFreeLunchDates.length) {
                isValid = false;
            } else if (isDutyFreeLunch === 'false' && !dutyFreeLunchReason) {
                isValid = false;
            } else if (isDutyFreeBreak === 'false' && !dutyFreeBreakDates.length) {
                isValid = false;
            } else if (isDutyFreeBreak === 'false' && !dutyFreeBreakReason) {
                isValid = false;
            }
        }

        setIsQuestionValidate(isValid);
    }

    useEffect(() => {
        if (!isOtherSelected) {
            setExplanation('');
        }

        validateQuestionResponses();
    }, [isOtherSelected]);

    useEffect(() => {
        let dutyFreeBreakSchoolSignatureTouched = dutyFreeBreakSchoolSigTouched;
        if (isDutyFreeBreak === 'true') {
            if (dutyFreeBreakSchoolSigTouched) {
                dutyFreeBreakSchoolSignatureTouched = false;
                setDutyFreeBreakSchoolSigTouched(dutyFreeBreakSchoolSignatureTouched);
            }

            if (dutyFreeBreakDates.length > 0) {
                setDutyFreeBreakDates([]);
            }

            if (dutyFreeBreakReason.length > 0) {
                setDutyFreeBreakReason('');
            }
        }

        let dutyFreeLunchSchoolSignatureTouched = dutyFreeLunchSchoolSigTouched;
        if (isDutyFreeLunch === 'true') {
            if (dutyFreeLunchSchoolSigTouched) {
                dutyFreeLunchSchoolSignatureTouched = false;
                setDutyFreeLunchSchoolSigTouched(dutyFreeLunchSchoolSignatureTouched);
            }

            if (dutyFreeLunchDates.length > 0) {
                setDutyFreeLunchDates([]);
            }

            if (dutyFreeLunchReason.length > 0) {
                setDutyFreeLunchReason('');
            }
        }

        setQuestionResponses({
            isDutyFreeLunch,
            dutyFreeLunchDates: dutyFreeLunchDates.map((date: any) => date.name).join(', '),
            dutyFreeLunchReason,
            dutyFreeBreakDates: dutyFreeBreakDates.map((date: any) => date.name).join(', '),
            dutyFreeBreakReason,
            dutyFreeBreakSchoolInitials: dutyFreeBreakSchoolSignatureTouched ?
                dutyFreeBreakSchoolInitials.current.getTrimmedCanvas().toDataURL('image/png') : '',
            dutyFreeLunchSchoolInitials: dutyFreeLunchSchoolSignatureTouched ?
                dutyFreeLunchSchoolInitials.current.getTrimmedCanvas().toDataURL('image/png') : '',
            isDutyFreeBreak,
            isWaiveMinimum,
            otherExplanation: explanation,
        })

        validateQuestionResponses();
    }, [
        isDutyFreeLunch,
        dutyFreeLunchDates,
        dutyFreeLunchReason,
        dutyFreeBreakDates,
        dutyFreeBreakReason,
        isDutyFreeBreak,
        isWaiveMinimum,
        explanation
    ])

    if (!state) {
        return null;
    }

    const isCA = state === "CA";
    let questionCount = 0;

    return (
        <Container data-testid="Disclaimer">
            {isCA && (
                <>
                    <div className={styles.Radios}>
                        <FormCheck.Label className={styles.radioLabel}>
                            {++questionCount}. Were you permitted to take a minimum 30-minute duty free lunch each day that you worked more than five hours?<span style={{ color: 'red' }}>*</span>
                        </FormCheck.Label>
                        {radios.map((radio) => (
                            <div key={`isDutyFreeLunch${radio.name}Container`} className="mb-2">
                                <Form.Check
                                    name='isDutyFreeLunch'
                                    type={'radio'}
                                    id={`isDutyFreeLunch${radio.name}`}
                                    label={radio.name}
                                    checked={isDutyFreeLunch === radio.value}
                                    value={radio.value}
                                    onChange={(e) => setIsDutyFreeLunch(e.currentTarget.value)}
                                />
                            </div>
                        ))}
                    </div>
                    {isDutyFreeLunch === 'false' && (
                        <div>
                            <Signature
                                name='dutyFreeLunchSchoolInitials'
                                title={"School Initials"}
                                reference={dutyFreeLunchSchoolInitials}
                                setSigTouched={setDutyFreeLunchSchoolSigTouched}
                            />
                            <Row>
                                <Col>
                                    <p><b>Date <span style={{ color: 'red' }}>*</span></b></p>
                                    <Multiselect
                                        options={options}
                                        selectedValues={dutyFreeLunchDates}
                                        onSelect={setDutyFreeLunchDates}
                                        onRemove={setDutyFreeLunchDates}
                                        displayValue="name"
                                    />
                                </Col>
                                <Col>
                                    <TextInput
                                        onValueChange={setDutyFreeLunchReason}
                                        values={dutyFreeLunchReason}
                                        title="Reason"
                                        name="reason"
                                        type={'text'}
                                        required
                                    />
                                </Col>
                            </Row>
                        </div>
                    )}
                    <div className={styles.Radios}>
                        <FormCheck.Label className={styles.radioLabel}>
                            {++questionCount}. Were you permitted to take two 10 minute duty free breaks, if you worked more than six hours? <span style={{ color: 'red' }}>*</span>
                        </FormCheck.Label>
                        {radios.map((radio) => (
                            <div key={`isDutyFreeBreak${radio.name}Container`} className="mb-2">
                                <Form.Check
                                    name='isDutyFreeBreak'
                                    type={'radio'}
                                    id={`isDutyFreeBreak${radio.name}`}
                                    label={radio.name}
                                    checked={isDutyFreeBreak === radio.value}
                                    value={radio.value}
                                    onChange={(e) => setIsDutyFreeBreak(e.currentTarget.value)}
                                />
                            </div>
                        ))}
                    </div>
                    {isDutyFreeBreak === 'false' && (
                        <div>
                            <Signature
                                name='dutyFreeBreakSchoolInitials'
                                title={"School Initials"}
                                reference={dutyFreeBreakSchoolInitials}
                                setSigTouched={setDutyFreeBreakSchoolSigTouched}
                            />
                            <Row>
                                <Col>
                                    <p><b>Date<span style={{ color: 'red' }}>*</span></b></p>
                                    <Multiselect
                                        options={options}
                                        selectedValues={dutyFreeBreakDates}
                                        onSelect={setDutyFreeBreakDates}
                                        onRemove={setDutyFreeBreakDates}
                                        displayValue="name"
                                    />
                                </Col>
                                <Col>
                                    <TextInput
                                        onValueChange={setDutyFreeBreakReason}
                                        values={dutyFreeBreakReason}
                                        title="Reason"
                                        name="reason"
                                        type={'text'}
                                        required
                                    />
                                </Col>
                            </Row>
                        </div>
                    )}
                    <div className={styles.Radios}>
                        <FormCheck.Label className={styles.radioLabel}>
                            {++questionCount}. If you worked 6 hours or less, did you choose to waive your minimum 30-minute unpaid lunch? <span style={{ color: 'red' }}>*</span>
                        </FormCheck.Label>
                        {waiveLunch.map((radio) => (
                            <div key={`isWaiveMinimum${radio.name}Container`} className="mb-2">
                                <Form.Check
                                    name='isWaiveMinimum'
                                    type={'radio'}
                                    id={`isWaiveMinimum${radio.name}`}
                                    label={radio.name}
                                    checked={isWaiveMinimum === radio.value}
                                    value={radio.value}
                                    onChange={(e) => setIsWaiveMinimum(e.currentTarget.value)}
                                />
                            </div>
                        ))}
                    </div>
                </>
            )}
            {isOtherSelected && (
                <TextInput
                    onValueChange={setExplanation}
                    required
                    name="explanation"
                    title={`${++questionCount}. If other listed above, please explain:`}
                    fieldValidation="required"
                    isFieldInvalid={isTimesheetSubmit && !explanation}
                    values={explanation}
                    type={'text'}
                />
            )}
        </Container >
    );
};

export default Questions;
